<app-header></app-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div *ngIf="isSidebarOpen" class="sidebar">
    <app-sidebar
      (myTaskSelection)="myTaskSelection($event)"
      [businessThemeLists]="businessThemeLists"
      [teamMembersLists]="teamMembersLists"
      [brandLists]="brandLists"
      [isTask]="true"
      (close)="toggleSidebar()"
      [quarter]="quarter"
    ></app-sidebar>
  </div>
  <div class="main-content p-t-20">
    <div class="container-fluid">
      <div>
        <p-breadcrumb
          class="max-w-full"
          [model]="breadCrumbItems"
          [home]="breadCrumbHome"
        >
          <ng-template pTemplate="item" let-item>
            <p class="b2 m-b-0">{{ item.label }}</p>
          </ng-template>
          <ng-template pTemplate="separator"> / </ng-template>
        </p-breadcrumb>
      </div>
      <div class="dis-flex flex-m flex-sb">
        <h1 class="font-medium m-b-0">My Tasks</h1>
        <div class="dis-flex">
          <div class="search-box-wrapper">
            <ng-icon
              name="hugeSearch01"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            <input
              class="radius-8 b2 m-r-20"
              type="text"
              pInputText
              [(ngModel)]="searchTerm"
              (ngModelChange)="filterQuarterlyOutcomes()"
              placeholder="Search"
            />
          </div>
          <button class="btn outline b2 wd-120px" (click)="toggleSidebar()">
            <ng-icon
              name="hugeFilter"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '' }}

          </button>
          <!-- <button
        class="btn clone-btn flex-c m-l-10 b2 wd-230px"
        (click)="cloneQuarterlyOutcomes()"
      >
        <ng-icon name="hugeCopy01" size="16" class="m-r-5 lh-1-0"></ng-icon>
        Clone Short Term Outcomes
      </button> -->
        </div>
      </div>

      <div class="body-card" *ngIf="!isLoading;else shimmerEffect">
        <p-scrollPanel>
          <div class="outcome-card w-full">
            <div
              class="quarterly-outcome-card"
              *ngIf="
                quarterlyOutcomesLists?.length;
                else noQuarterlyOutcomesLists
              "
            >
              <app-virtual-scroll
                class="w-full"
                [data]="myTasksData"
                [apiUrl]="myTaskUrl"
                (loadedData)="onDataLoaded($event)"
              >
                <app-quarterly-outcome
                  [isMytask]="isMytask"
                  [isLoading]="isLoading"
                  [quarterlyOutcomesLists]="quarterlyOutcomesLists"
                  (notifyParent)="handleChildEvent($event)"
                ></app-quarterly-outcome>
              </app-virtual-scroll>
            </div>
            <!-- <div class="quarterly-outcome-card">
            <app-quarterly-outcome></app-quarterly-outcome>
            <app-milestone></app-milestone>
          </div> -->
          </div>
        </p-scrollPanel>
      </div>

      <app-quick-action></app-quick-action>
    </div>
  </div>
</div>
<!-- Clone Quarterly Outcome Modal -->
<!-- <p-dialog
  header="Clone Short Term Outcomes and its Milestones"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="cloneModal"
  [style]="{ width: '50rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-30">
    <div class="dis-flex radius-8 border-20 p-t-20 p-b-20 p-l-20 p-r-20">
      <p-table
        [value]="quarterlyOutcomes"
        [scrollable]="true"
        scrollHeight="50vh"
        class="clone-quarterly-table w-full"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
            <th class="text-left">STO</th>
            <th>Milestones Count</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-q>
          <tr>
            <td>
              <p-tableCheckbox [value]="q" />
            </td>
            <td class="text-left">{{ q.name }}</td>
            <td>
              <span>{{ q.milestoneCount }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button class="btn outline wd-100px m-r-10">Cancel</button>
    <button class="btn primary wd-100px">Done</button>
  </div>
</p-dialog> -->

<ng-template #shimmerEffect>
 <app-shimmer-list [count]="6"></app-shimmer-list>
</ng-template>

<ng-template #noQuarterlyOutcomesLists>
  <app-no-data-found></app-no-data-found>
</ng-template>
